module.exports = __webpack_public_path__ + "static/img/1_26_1.f7969189.png";